import React from 'react';
import { Helmet } from 'react-helmet';

interface PropertyStructuredDataProps {
  mlsNumber: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  squareFeet: number;
  description: string;
  images: string[];
  listingDate: string;
}

export const PropertyStructuredData: React.FC<PropertyStructuredDataProps> = ({
  mlsNumber,
  address,
  city,
  state,
  zipCode,
  price,
  bedrooms,
  bathrooms,
  squareFeet,
  description,
  images,
  listingDate
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "RealEstateListing",
    "@id": `https://chat.realestate/property/${mlsNumber}`,
    "name": `${address}, ${city}, ${state}`,
    "url": `https://chat.realestate/property/${mlsNumber}`,
    "datePosted": listingDate,
    "description": description,
    "image": images,
    "numberOfRooms": bedrooms,
    "numberOfBathroomsTotal": bathrooms,
    "floorSize": {
      "@type": "QuantitativeValue",
      "value": squareFeet,
      "unitCode": "SQFT"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": address,
      "addressLocality": city,
      "addressRegion": state,
      "postalCode": zipCode,
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": null, // Would be populated from property data
      "longitude": null
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "USD",
      "price": price,
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <meta property="og:title" content={`${address}, ${city}, ${state}`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={images[0]} />
      <meta property="og:url" content={`https://chat.realestate/property/${mlsNumber}`} />
      <meta property="og:type" content="website" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${address}, ${city}, ${state}`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={images[0]} />
    </Helmet>
  );
};